// Type definitions available if needed for future use
// type StrapiResponse<T> = {
//   data: T;
// };

// type StrapiMedia = {
//   data?: {
//     attributes?: {
//       url?: string;
//     };
//   } | null;
//   url?: string;
// } | null;

// type StrapiEvent = {
//   event_id: string;
//   logo?: StrapiMedia;
//   name?: string;
// };

// type StrapiItem<T> = {
//   id: number | string;
//   attributes?: T;
// } & Partial<T>;

// function getStrapiBaseUrl(): string { // Available if needed for future use
//   const base = process.env.REACT_APP_STRAPI_URL || '';
//   return base.replace(/\/?$/, '');
// }

// function mediaUrl(strapiBase: string, m: any | null | undefined): string | null {
//   if (!m) return null;
//   const url: string | undefined = (m as any).url || (m as any)?.data?.attributes?.url;
//   if (!url) return null;
//   if (url.startsWith('http')) return url;
//   if (!strapiBase) return null;
//   return `${strapiBase}${url}`;
// }

// async function strapiGet(path: string): Promise<any> {
//   const base = getStrapiBaseUrl();
//   if (!base) return null;
//   const url = `${base}${path}`;

//   const controller = new AbortController();
//   const timeoutMs = 5000;
//   const timer = setTimeout(() => controller.abort(), timeoutMs);

//   try {
//     let res;
//     try {
//       res = await fetch(url, {
//         signal: controller.signal,
//         headers: {
//           Accept: 'application/json',
//         },
//       });
//     } catch {
//       return null;
//     }
//     if (!res.ok) {
//       throw new Error(`Strapi request failed: ${res.status} ${res.statusText} (${url})`);
//     }
//     return await res.json();
//   } finally {
//     clearTimeout(timer);
//   }
// }

export async function getEventLogoUrl(eventId: string): Promise<string | null> {
  // Use local logo files instead of Strapi dependency
  if (!eventId) return null;
  
  const eventIdLower = eventId.toLowerCase();
  
  // Map event IDs to local logo files
  if (eventIdLower === 'kutc') {
    return '/images/KUTC_logo.svg';
  } else if (eventIdLower === 'mo') {
    return '/images/MO_logo.png';
  }
  
  // No local logo available for this event
  return null;
}

export async function getEventLogoUrls(eventIds: string[]): Promise<Record<string, string>> {
  const unique = Array.from(new Set((eventIds || []).filter(Boolean).map((s) => s.toLowerCase())));
  const results: Record<string, string> = {};

  await Promise.all(
    unique.map(async (id) => {
      try {
        const url = await getEventLogoUrl(id);
        if (url) results[id] = url;
      } catch {
        // ignore
      }
    })
  );

  return results;
}
